import { render } from "./ReturnParcelDetails.vue?vue&type=template&id=748aa2d4&ts=true"
import script from "./ReturnParcelDetails.vue?vue&type=script&lang=ts"
export * from "./ReturnParcelDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__